import { ReactElement } from 'react';

import { ResultTypes } from '@cashier/cashier-model';
import { useUIConfiguration } from '@cashier/cashier-shared';

import { usePaymentResult } from '../hooks';
import { InformationBlock } from '../modules/informationBlock/v2';
import { StatusBlock } from '../modules/statusBlock/v2';

export interface PaymentResultProps {
  amount: string;
  currency: string;
  noVerticalPadding?: boolean;
}

export const PaymentResult = ({
  amount,
  currency,
  noVerticalPadding = false,
}: PaymentResultProps): ReactElement => {
  const { resultType, paymentMethodMessage, informationFields, onButtonClick } =
    usePaymentResult();
  const informationBlockType = useUIConfiguration('informationBlock', 'type');

  return (
    <>
      {resultType === ResultTypes.INFORMATION && (
        <InformationBlock
          amount={amount}
          currency={currency}
          paymentMethodMessage={paymentMethodMessage}
          fields={informationFields}
          type={informationBlockType}
          onButtonClick={onButtonClick}
        />
      )}
      {resultType === ResultTypes.STATUS && (
        <StatusBlock
          noVerticalPadding={noVerticalPadding}
          onButtonClick={onButtonClick}
        />
      )}
    </>
  );
};
